export default __webpack_public_path__ + "static/media/sample-FP-L3.8c03cc41.png";